module.exports = __webpack_public_path__ + "img/STERiGLIDE_02.bbb3f3b6.jpg";